import React from 'react';
import Button from 'common/components/Button';
import { ButtonSchema, ButtonSize } from 'common/components/Button/constants';
import { useTranslateFn } from 'utils/useTranslateFn';
import styles from './styles.module.scss';

interface IGroupManagementBlockProps {
  onAddToGroup: () => void;
  onAddAndBuildAnother: () => void;
  onStartOver: () => void;
  isEditing: boolean;
  isAtLimit: boolean;
  isAdding?: boolean;
  isCompleted?: boolean;
}


const GroupManagementBlock = ({
  onAddToGroup,
  onAddAndBuildAnother,
  onStartOver,
  isEditing,
  isAtLimit,
  isAdding = false,
  isCompleted = false,
}: IGroupManagementBlockProps) => {
  const t = useTranslateFn<string>();

  return (
    <div className={styles.groupManagement}>
      <Button
        schema={ButtonSchema.secondary}
        size={ButtonSize.standard}
        onClick={onAddToGroup}
        disabled={isAdding || isCompleted}
      >
        <span className={styles.buttonIconPlus}>&#x2b;</span>
        <span className={styles.buttonLabel}>
          {isEditing
            ? t('texts.assemblyGroup.updateButton')
            : t('texts.assemblyGroup.addButton')}
        </span>
      </Button>
      <Button
        schema={ButtonSchema.secondary}
        size={ButtonSize.standard}
        onClick={onAddAndBuildAnother}
        disabled={isAtLimit || isAdding || isCompleted}
      >
        <span className={styles.buttonIcon}>&#x27f3;</span>
        <span className={styles.buttonLabel}>{t('texts.assemblyGroup.addBuildAnother')}</span>
      </Button>
      <Button
        schema={ButtonSchema.secondary}
        size={ButtonSize.standard}
        onClick={onStartOver}
      >
        <span className={styles.buttonIconSmall}>&#x2715;</span>
        <span className={styles.buttonLabel}>{t('texts.assemblyGroup.startOver')}</span>
      </Button>
    </div>
  );
};

export default GroupManagementBlock;
